import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LabelBody, LabelResponse } from '@shared/interfaces/labels.interface';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LabelsService {
  labels : LabelResponse[] = [];

  // Map of label UUID -> LabelResponse for fast lookup
  private labelUUIDMap: Record<string, LabelResponse> = {};

  constructor(private http : HttpClient) {
  }

  fetchLabels = () => {
    this.getLabels().subscribe((res : any) => {
      this.labels = res;
      this.getLabelUUID(this.labels);
    })
  }

  getLabels(params: any = {}): Observable<any> {
    return this.http.get(`/api/labels`, { params });
  }

  getLabelUUID = (labels:any) => {
    this.labelUUIDMap = {};
    labels.forEach((label:any) => {
      this.labelUUIDMap[label.uuid] = label;
    });
  }

  /**
   * Typed accessor for the UUID -> Label map.
   */
  getLabelUUIDMap(): Record<string, LabelResponse> {
    return this.labelUUIDMap;
  }

  setLabel = (body:LabelBody) : Observable<any> => {
    return this.http.post('/api/search/label', body);
  }

  createNewLabel(payload:any = {}): Observable<any> {
    return this.http.post('/api/labels', payload);
  }

  updateLabel(payload:any = {}, params: any = {}): Observable<any> {
    return this.http.put('/api/labels/'+params._id, payload );
  }

  deleteLabel( params: any = {}): Observable<any> {
    return this.http.delete('/api/labels/'+params._id) ;
  }

  // Get labels filtered by module
  getLabelsByModule(module: 'search' | 'reports-iq' | 'claims'): LabelResponse[] {
    return this.labels.filter(label => label.module === module);
  }

  // Claims module: Update labels for a specific claim
  updateClaimLabels(
    claimId: string,
    labelUuid: string,
    operation: 'add' | 'remove'
  ): Observable<any> {
    return this.http.put(`/api/claims/${claimId}/labels`, {
      labelUuid,
      operation
    });
  }

  // Reports-IQ module: Update labels for exceptions/summary records
  updateExceptionLabels(
    tableName: string,
    referenceId: string,
    labelUuid: string,
    operation: 'add' | 'remove'
  ): Observable<any> {
    return this.http.put(`/api/exceptions/${tableName}/${referenceId}/labels`, {
      labelUuid,
      operation
    });
  }

}
